import React from "react";
import PropTypes from "prop-types";
import "./step.css";

export const Step = ({ status }) => {
  const getBackgroundColor = () => {
    switch (status) {
      case "complete":
        return "bg-blue-700";
      case "current":
        return "bg-blue-700 loading";
      default:
        return "bg-gray-100";
    }
  };

  return (
    <li className="flex-1">
      <div
        className={`h-2 ${getBackgroundColor()} transition-all duration-300 ease-in-out`}
      />
    </li>
  );
};

Step.propTypes = {
  status: PropTypes.oneOf(["complete", "current", "incomplete"]).isRequired,
};
